import EN from '../../EN.json';

const { signingErrors = {} } = EN.contractSignature || {};

// Stable backend error codes returned by POST /orders/contract-signed (T050).
export const SIGN_CONTRACT_ERROR_CODES = [
  'ORDER_NOT_FOUND',
  'ALREADY_SIGNED',
  'CONTRACT_CANCELLED',
  'CONTRACT_NOT_AVAILABLE'
];

/**
 * Extracts a stable signing error code from either a JSON body
 * (`{ success: 0, code }`, HTTP 200) or a thrown axios error (`HTTP 409`
 * with `response.data.code`). Returns null when no code is present — the
 * caller then preserves legacy behavior (older backend / version skew).
 */
export const extractSignContractErrorCode = ({ data, error } = {}) => {
  if (data && data.code) return data.code;
  const responseCode =
    error && error.response && error.response.data && error.response.data.code;
  return responseCode || null;
};

/**
 * Maps a backend signing error code to a user-safe message.
 * Unknown/absent code → null so the caller can fall back to legacy handling.
 */
export const resolveSignContractErrorMessage = code => {
  if (!code) return null;
  return signingErrors[code] || signingErrors.GENERIC || null;
};

export default resolveSignContractErrorMessage;
